import { firebaseDb, uid } from './index'

export const saveTags = (dispatch, onSuccess, userTags, actionTags,
    projectId) => {
  let updates = {}
  updates[`users/${uid()}/tags`] = userTags
  updates[`tags/${projectId}`] = actionTags
  firebaseDb().ref().update(updates)
    .then(() => {
      dispatch(onSuccess(userTags, actionTags, projectId))
    })
    .catch((error) => {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/Firebase/apiTags.js